module.exports = __webpack_public_path__ + "static/media/logo.8547f4eb.jpg";